<template>
  <div class="ali-player">
    <div id="video"></div>
  </div>
</template>
<script>
export default {
  name: 'trainingVideo',
  components: {},
  props: {
    sourceUrl: {
      type: [String, Array, Object],
      default: () => {
        return ""
      }
    },
    sourceUrlArray:{
      type: [Array,Object] ,
      default: () =>{
        return []
      }
    },
    isArray: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '1015px'
    },
    height: {
      type: String,
      default: '574px'
    },
    /**
     * 拖动状态：  1正常拖动 0 禁止拖动 2 只能前进  3 只能后退 4  能回到第一次拖动时的位置
     */
    timeScheduleAdjust: {
      type: Number,
      default: 3
    },
    // videoSeekTime: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      //视频播放配置对象
      videoObject: {
        width: this.width,
        height: this.height,
        container: "#video",
        //该属性必需设置，值等于下面的new chplayer()的对象
        variable: "player",
        // crossdomain:"/static/ckplayer/crossdomain.xml",
        //禁止自动播放功能
        autoplay: false,
        unescape:true,
        live: false,
        playbackrateOpen: false,
        loaded: this.loadedHandlerSucess
      },
      // 播放器对象
      player: undefined,
      //当前播放时间 （单位：秒）
      currentTime: 0,
      loaded: false,

      // 跳转时间 为 “0” 表示不做跳转
      videoSeekTime: 0
    }
  },
  methods: {
    /**
     * 暂停
     **/
    pause() {
      // this.player.videoPause();
      this.player.pause()
    },
    /**
     * 播放
     * */
    play() {
      this.player.play();
    },
    /**
     * 暂停 或 播放
     */
    playOrPause() {
      this.player.playOrPause();
    },
    /**
     * 退出全屏播放
     */
    quitFullScreen() {
      //退出全屏播放
      this.player.quitFullScreen();
    },
    /**
     * 初始化播放视频
     */
    playVideo() {
      // this.videoObject.video = encodeURI(this.sourceUrl);

console.log(this.sourceUrl)
      // if(this.sourceUrl instanceof  Array){
      //   console.log(this.sourceUrl[0][0])
      //   this.sourceUrl[0][0]=decodeURI(this.sourceUrl[0][0])
      // }
      //
      this.videoObject.video = this.sourceUrl;
      this.player = new ckplayer(this.videoObject);
      this.loadedHandler();
      this.pause();
    },
    /**
     * 初始化成功回调
     */
    loadedHandlerSucess() {
      this.loaded = true;
      this.refreshConfig();
    },
    /**
     * 刷新配置
     **/
    refreshConfig() {
      // console.log("--------timeScheduleAdjust-------",this.timeScheduleAdjust)
      // this.player.changeConfig('config','timeScheduleAdjust', this.timeScheduleAdjust);
      this.videoSeek(this.videoSeekTime);
      this.player.vars({'timeScheduleAdjust': this.timeScheduleAdjust})
      // this.player.videoPause();
    },
    /**
     * 注册监听函数
     **/
    loadedHandler() {
      this.player.addListener('full', this.fullHandler);
      this.player.addListener('time', this.timeHandler);
      this.player.addListener('play', this.playHandler);
      this.player.addListener('pause', this.pauseHandler);
      this.player.addListener('ended', this.endedHandler);
      // let metaData = this.player.getMetaDate();
      // let html = ''
      // html += '总时间：' + metaData['duration'] + '秒，';
      // html += '音量：' + metaData['volume'] + '（范围0-1），';
      // html += '播放器的宽度：' + metaData['width'] + 'px，';
      // html += '播放器的高度：' + metaData['height'] + 'px，';
      // html += '视频宽度：' + metaData['videoWidth'] + 'px，';
      // html += '视频高度：' + metaData['videoHeight'] + 'px，';
      // html += '视频原始宽度：' + metaData['streamWidth'] + 'px，';
      // html += '视频原始高度：' + metaData['streamHeight'] + 'px，';
      // html += '是否暂停状态：' + metaData['paused'];
      // console.log('html:' +  html)
    },
    /**
     * 开始播放回调
     */
    playHandler() {
      this.$emit("onPay", {});
    },
    /**
     * 播放暂停回调
     */
    pauseHandler() {
      this.$emit("onPause", {});
    },
    /**
     * 全屏播放回调
     */
    fullHandler() {
      this.$emit("onFull", {});
    },
    /**
     * 实时播放时间函数回调
     */
    timeHandler(time) {
      this.currentTime = time;
      this.$emit("onTime", time);
    },
    /**
     * 播放结束回调
     */
    endedHandler() {
      this.$emit("onEnded");
    },
    /**
     * 跳转到指定的播放时间
     * @param time 跳转到的目标时间，单位 秒
     */
    videoSeek(time) {
      this.videoSeekTime = time;
      //判断是否加载完成
      if (this.loaded) {
        setTimeout(() => {
          if (this.videoSeekTime && this.videoSeekTime > 0) {
            this.player.seek(this.videoSeekTime);
            this.pause();

          }
        }, 10)
      }
    },
    /**
     * 跳转到指定的播放时间
     * @param time 跳转到的目标时间，单位 秒
     */
    videoSeekFiltr(time) {
      this.videoSeekTime = time;
      //判断是否加载完成
      if (this.loaded) {
        setTimeout(() => {
          if (this.videoSeekTime && this.videoSeekTime > 0) {
            this.player.seekFiltr(this.videoSeekTime);
            this.pause();
          }
        }, 10)
      }
    },
    /**
     * 获取当前视频播放时间
     * @returns {number} 返回当前视频播放时间 单位：秒
     */
    getCurrentTime() {
      return this.currentTime ? this.currentTime : 0;
    },
    /**
     * 设置进度条拖动模式
     * @param timeScheduleAdjust
     */
    setTimeScheduleAdjust(timeScheduleAdjust) {
      console.log("--------setTimeScheduleAdjust------------", timeScheduleAdjust)
      this.timeScheduleAdjust = timeScheduleAdjust;
      this.player.vars({'timeScheduleAdjust': Number(this.timeScheduleAdjust)})
    },
    handleKeyDown(event) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      console.log(e.keyCode)
      if (e && e.keyCode === 38) {
          this.player.vars({'timeScheduleAdjust': 1})
          this.player.fastNext(15)
          this.$emit("onFastNext", 15);
          setTimeout(() => {
            this.$nextTick(() => {
              this.player.vars('timeScheduleAdjust', Number(this.timeScheduleAdjust))
            })
          }, 100);
          return false;
      }
    }
  },
  mounted() {
    //初始化视频播放
    this.playVideo();
  },
  created() {
    document.addEventListener('keyup', this.handleKeyDown)
  },
  beforeDestroy() {
    // 在组件销毁前确保取消监听，以防止内存泄漏
    document.removeEventListener('keyup', this.handleKeyDown)
  },
  watch: {
    sourceUrl: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          // this.waiting = true
          // this.sourceUrl = newVal
          this.currentTime = 0;
          this.playVideo()
        }
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: false
    },
    sourceUrlArray: {
      immediate: true,
      handler(newVal, oldVal) {
        if (this.isArray) {
          if (newVal && newVal.length > 0) {
            this.sourceUrl=newVal
            this.playVideo();
          }

        }
      }
    },
    // videoSeekTime: {
    //   immediate: true,
    //   handler(newVal, oldVal) {
    //     if (newVal && newVal !== oldVal) {
    //       this.$nextTick(() => {
    //         if (newVal && newVal > 0) {
    //           this.player.vars({'maxSeeTime': newVal})
    //           this.player.seek(newVal+1);
    //         }
    //       })
    //     }
    //
    //   },
    // },
    timeScheduleAdjust: {
      immediate: true,
      handler(newVal, oldVal) {
        // console.log(newVal && newVal !== oldVal)
        if (newVal && newVal !== oldVal) {
          console.log("==-----开始变更视频状态")
          this.$nextTick(() => {
            this.player.vars({'timeScheduleAdjust': Number(this.timeScheduleAdjust)})
            // this.player.changeConfig('config','timeScheduleAdjust', newVal);
          })
          console.log("==-----结束变更视频状态")
        }
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      // immediate: false
    },
    // loaded: {
    //   handler(newVal, oldVal) {
    //     if( newVal && newVal !== oldVal) {
    //       this.refreshConfig();
    //     }
    //   },
    //   // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
    //   immediate: false
    // }
    deep: true, // 是否开启深度监听
    immediate: true, // 是否初始化时就执行一次
  }
}
</script>

<style lang="scss" scoped>
.ali-player {
  width: 100%;

  .main {
    box-sizing: border-box;
    color: #FFFFFF;

    .video-center {
      position: relative;

      .name {
        position: absolute;
        left: 50%;
        top: -20px;
        font-size: 18px;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
      }

      .tips {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 9999;
        opacity: 0.79;
      }
    }
  }

  #video {
    width: 100%;
    height: 500px !important;
    opacity: 0.79;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/training/trainingVideo.vue